import Vue from "vue";
import Component from "vue-class-component";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "AccountNotificationPreferences" })
export default class AccountNotificationPreferences extends Vue {
    public localizer: any = Localizer;
    public isLoading: boolean = false;
    public isSuccess: boolean = false;
    public formData: any = null;
    public interests: any[] = [];
    public regions: any[] = [];
    public selectedRegion: any = null;
    public validationErrors: any[] = [];

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        await this.getData();
    }

    public async getData() {
        const result = (await Axios.post(this.routes.MyBremboPartsProfile_GetNotificationData, null)).data;

        this.formData = result.myNewsletterInfo;
        this.interests = result.interests;
        this.regions = result.regions;

        this.selectedRegion = this.regions.filter(x => x.languages.some(y => y.culture === this.formData.culture))[0];
    }

    public async newsletterSubscribe() {
        this.validationErrors = [];
        this.isLoading = true;

        try {
            await Axios.post(this.routes.MyBremboPartsProfile_NewsletterSubscribe, this.formData);
        }
        catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        await this.getData();
        this.isLoading = false;
    }

    public async newsletterUnsubscribe() {
        this.validationErrors = [];
        this.isLoading = true;

        try {
            await Axios.post(this.routes.MyBremboPartsProfile_NewsletterUnsubscribe, null);
        }
        catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        await this.getData();
        this.isLoading = false;
    }

    public async submitForm() {
        this.validationErrors = [];
        this.isLoading = true;

        try {
            await Axios.post(this.routes.MyBremboPartsProfile_NewsletterUpdate, this.formData);

            this.isSuccess = true;
            setTimeout(x => { this.isSuccess = false }, 2500);
        }
        catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        await this.getData();
        this.isLoading = false;
    }
};